import React from 'react';
import { Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { makePayment, generateLetter, deleteAccount } from '../../API';
import { getCurrency, toggleOptionsMenu, getShortDate } from '../../Helper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle, faSquare } from '@fortawesome/free-regular-svg-icons'
import { faCheckCircle, faCheckSquare, faEye, faEdit, faEllipsisH, faEnvelope, faMapMarkerAlt, faCity, faUser, faAsterisk, faDollarSign, faBan, faHashtag, faUsers, faCalendarAlt, faFileAlt, faArrowCircleRight } from '@fortawesome/free-solid-svg-icons'

function CheckRegisterCard(props) {

    const defaultOptions = {
        fields: {
            division: true,
            feeType: true,
            checkFrom: true,
            checkNumber: true,
            amount: true,
            checkDate: true,
            receivedDate: true,
            comments: true
        },
        actions: {
            view: true,
            select: false,
            cancel: false
        }
    };

    const options = { ...defaultOptions, ...props.options };

    const toggleSelect = () => {
        if (props.selected) {
            props.deselect(props.check.PK_ID);
        } else {
            props.select(props.check);
        }
    };

    const cancel = () => {
        props.cancel(props.check.PK_ID);
    };

    const viewURL = 'https://intranetdenr.sd.gov/dbFOchecksearch.htm';

    return (
        <div className="card item-details">
            <div className="properties">
                {options.fields.division ? (
                    <div className="svg-label tooltip-parent">
                        <FontAwesomeIcon icon={faUsers} />
                        <span>{props.check.Program}</span>
                        <div className="tooltip-target tooltip-top">
                            DANR Program
                        </div>
                    </div>
                ) : null}
                {options.fields.checkNumber ? (
                    <div className="svg-label tooltip-parent">
                        <FontAwesomeIcon icon={faHashtag} />
                        <span>{props.check.CheckNum}</span>
                        <div className="tooltip-target tooltip-top">
                            Check Number
                        </div>
                    </div>
                ) : null}
                {options.fields.feeType ? (
                    <div className="svg-label tooltip-parent">
                        <FontAwesomeIcon icon={faArrowCircleRight} />
                        <span>{props.check.FeeType}</span>
                        <div className="tooltip-target tooltip-top">
                            Payment For
                        </div>
                    </div>
                ) : null}
                {options.fields.checkFrom ? (
                    <div className="svg-label tooltip-parent">
                        <FontAwesomeIcon icon={faUser} />
                        <span>{props.check.CheckFrom}</span>
                        <div className="tooltip-target tooltip-top">
                            Check From
                        </div>
                    </div>
                ) : null}
                {options.fields.amount ? (
                    <div className="svg-label tooltip-parent">
                        <FontAwesomeIcon icon={faDollarSign} />
                        <span>{getCurrency(props.check.Amount)}</span>
                        <div className="tooltip-target tooltip-top">
                            Amount
                        </div>
                    </div>
                ) : null}
                {options.fields.checkDate ? (
                    <div className="svg-label tooltip-parent">
                        <FontAwesomeIcon icon={faCalendarAlt} />
                        <span>{getShortDate(props.check.CheckDate)}</span>
                        <div className="tooltip-target tooltip-top">
                            Check Date
                        </div>
                    </div>
                ) : null}
                {options.fields.receivedDate ? (
                    <div className="svg-label tooltip-parent">
                        <FontAwesomeIcon icon={faCalendarAlt} />
                        <span>{getShortDate(props.check.RecdDate)}</span>
                        <div className="tooltip-target tooltip-top">
                            Received Date
                        </div>
                    </div>
                ) : null}
                {options.fields.comments ? (
                    <div className="svg-label tooltip-parent">
                        <FontAwesomeIcon icon={faFileAlt} />
                        <span>{props.check.Comments}</span>
                        <div className="tooltip-target tooltip-top">
                            Comments
                        </div>
                    </div>
                ) : null}
            </div>
            {options.actions ? (
                <div className="actions">
                    {options.actions.view ? (
                        <Link to={viewURL} className="action-icon action-view">
                            <FontAwesomeIcon icon={faEye} />
                        </Link>
                    ) : null}
                    {options.actions.select ? (
                        <div onClick={toggleSelect} className="action-icon">
                            <FontAwesomeIcon icon={props.selected ? faCheckCircle : faCircle} />
                        </div>
                    ) : null}
                    {options.actions.cancel ? (
                        <div onClick={cancel} className="action-icon action-delete">
                            <FontAwesomeIcon icon={faBan} />
                        </div>
                    ) : null}
                </div>
            ) : null}
        </div>
    )
}

export default CheckRegisterCard;